<template>
<div class="table-action-header">
  
  <div v-if="selectOptions" class='search-options' :style="selectOptionsStyle">
    <SelectList :options="selectOptions" :value="selected" @select="onSelect" :searchable="selectListClearable" :clearable="selectListClearable" :placeholder="selectListPlaceholder"/>
  </div>
  <div v-if="selectOptions2" class='search-options' :style="selectOptionsStyle">
    <SelectList :options="selectOptions2" :value="selected2" @select="onSelect2" :searchable="selectListClearable" :clearable="selectListClearable" :placeholder="selectListPlaceholder"/>
  </div>
   <div v-if="selectOptions3" class='search-options' :style="selectOptionsStyle">
    <SelectList :options="selectOptions3" :value="selected3" @select="onSelect3" :searchable="selectListClearable" :clearable="selectListClearable" :placeholder="selectListPlaceholder"/>
  </div>
  <div v-if="searchInput" class='search-input'>
      <!--fg-input v-model="filter" @input="filterChange" type="search" :placeholder="$t('button.search')" addon-left-icon="fa fa-search" ></fg-input-->
      <!--b-form-input v-model="filter" @update="filterChange" type="search" :placeholder="$t('button.search')" debounce="300"></b-form-input-->

      <b-input-group class='table-search-input'>
        <b-input-group-prepend is-text><b-icon icon="search"></b-icon></b-input-group-prepend> 
        <b-form-input v-model="filter" @update="filterChange" type="search" :placeholder="$t('button.search')" debounce="300"></b-form-input>
      </b-input-group>
  </div>  
  <p-button v-if="newButton" id='new-item' @click="newItem" type="default" size="sm" outline class="float-right"><i class="fa fa-plus"></i><span>{{ $t('button.new') }}</span></p-button> 

 
</div>
</template>

<script>

import SelectList from '@/components/Misc/SelectList'

export default {
  name: 'TableActionHeader',
  components: { 
        SelectList
  },
  props: {
    searchInput: {type: Boolean, default: true },
    newButton: {type: Boolean, default: true },
    selectOptions: { default: null },
    selected: { default: null },
    selectListClearable: {type: Boolean, default: false},
    selectListWidth: {default: "11vw"},
    selectListPlaceholder: {default: null},

    selectOptions2: { default: null },
    selected2: { default: null },
    selectOptions3: { default: null },
    selected3: { default: null },
  },
  data: function() {
    return {
      filter: null
    }
  },
  computed: {
    selectOptionsStyle(){
      return "width:" + this.selectListWidth
    }
  },
  methods: {
    setFilterValue(newval) {
      this.filter = newval;
    },
    filterChange() {
      this.$emit('filterChange', this.filter);
    },
    newItem(){
      this.$emit('newItem');
    },
    onSelect(id) {
      this.$emit('filterSelect', id);
    },
    onSelect2(id) {
      this.$emit('filterSelect2', id);
    },
    onSelect3(id) {
      this.$emit('filterSelect3', id);
    }
 }
}
</script>

<style scoped lang="scss">

.table-action-header {
  height: 50px;
}

div.search-input {
  display: block;
  width: 11vw;
  float: left;
}

  .vs__selected {
    color: blue;
  }


div.search-options {
  width: 11vw;
  float: left;
  margin-right: 10px;
}

#new-item {
  margin: 0;
}

#new-item span {
  display: none;
}
#new-item:hover span {
  display: inline;
}

.table-search-input {
  .form-control:focus {
    border-color: rgb(221,221,221);
  }
}

</style>
